import { StoreKey } from "lib/Intl";
import { CountryCode } from "libphonenumber-js";

export const DEFAULT_COUNTRY_CODES: Record<StoreKey, CountryCode> = {
  "OT-COM": "NL",
  "OT-NL": "NL",
  "OT-BE": "BE",
  "OT-DE": "DE",
  "OT-FR": "FR",
  "OT-ES": "ES",
  "OT-IT": "IT",
  "OT-UK": "GB",
  "pl-PL": "PL",
  "OT-ZZ": "NL",
  "": "NL",
  "OT-US": "US",
};
